import api, { unwrap } from './client';

export async function getProfile() {
  return unwrap(await api.get('/users/me'));
}

export async function updateProfile(payload) {
  return unwrap(await api.put('/users/me/profile', payload));
}

export async function listAdminUsers(params = {}) {
  return unwrap(await api.get('/admin/users', { params }));
}
